var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceOrdercheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 13C13.8954 13 13 13.8954 13 15V33C13 34.1046 13.8954 35 15 35H33C34.1046 35 35 34.1046 35 33V15C35 13.8954 34.1046 13 33 13H15ZM30.7071 20.7071C31.0976 20.3166 31.0976 19.6834 30.7071 19.2929C30.3166 18.9024 29.6834 18.9024 29.2929 19.2929L22 26.5858L18.7071 23.2929C18.3166 22.9024 17.6834 22.9024 17.2929 23.2929C16.9024 23.6834 16.9024 24.3166 17.2929 24.7071L21.2929 28.7071C21.6834 29.0976 22.3166 29.0976 22.7071 28.7071L30.7071 20.7071Z",
    fill: "#363A4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceOrdercheck);
export default __webpack_public_path__ + "static/media/service_ordercheck.ace3d37059cec5caf150151d0b3df144.svg";
export { ForwardRef as ReactComponent };